import { render, staticRenderFns } from "./DeliverGoods.vue?vue&type=template&id=4b5902fa&scoped=true"
import script from "./DeliverGoods.vue?vue&type=script&lang=js"
export * from "./DeliverGoods.vue?vue&type=script&lang=js"
import style0 from "./DeliverGoods.vue?vue&type=style&index=0&id=4b5902fa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5902fa",
  null
  
)

export default component.exports